import { render } from "./PurchaseTableMonitor.vue?vue&type=template&id=454340ff"
import script from "./PurchaseTableMonitor.vue?vue&type=script&lang=js"
export * from "./PurchaseTableMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__